import { render, staticRenderFns } from "./ModelPresetManage.vue?vue&type=template&id=28365213&scoped=true&"
import script from "./ModelPresetManage.vue?vue&type=script&lang=js&"
export * from "./ModelPresetManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28365213",
  null
  
)

export default component.exports